import { between } from '@apparel/core/utils/between';

export interface ActionOption {
    step?: number;
    min?: number;
    max?: number;
}

/**
 * @protected
 * @param value
 * @param options
 */
export const mapValue = (value: any, options?: ActionOption): number | string => {
    value = `${value ?? ''}`.trim().replace(/\D/g, '');
    if (value) {
        return between(parseInt(value), options?.min, options?.max);
    }

    return options?.min || '';
};

const _valueAction = (value: any, options: ActionOption & { action?: 'increment' | 'decrement' } = {}) => {
    let value$ = value || 0;

    const options$ = {
        step: 1,
        ...options,
    };

    switch (options.action) {
        case 'decrement':
            value$ -= options$.step;
            break;
        case 'increment':
            value$ += options$.step;
            break;
    }

    return between(value$, options$.min, options$.max);
};

/**
 * @protected
 * @param value
 * @param options
 */
export const decrement = (value: any, options: ActionOption) =>
    _valueAction(value, { action: 'decrement', ...options });

/**
 * @protected
 * @param value
 * @param options
 */
export const increment = (value: any, options: ActionOption) =>
    _valueAction(value, { action: 'increment', ...options });
